import { lazy, useEffect } from 'react';

import { setIsDriveTest } from '../../redux/Slices/StartTestSlice/startFulTest';
import { useAppDispatch, useAppSelector } from '../../redux/store/hooks';

const DashboardPage = lazy(() => import('../../pages/Dashboard'));

const DriveTestPage = () => {
  const dispatch = useAppDispatch();
  const { isDriveTest } = useAppSelector(state => state.root.startFulltest);

  const location = window.location.pathname;

  useEffect(() => {
    if (location === '/drive-test') {
      dispatch(setIsDriveTest(true));
    }
  }, [location, isDriveTest]);

  return (
    <div className='h-full'>
      <DashboardPage />
    </div>
  );
};

export default DriveTestPage;
